import Property from './Property';
import KeyPager from './KeyPager';

const ListingCount = ({
  total = 0,
  active = 0,
  inactive = 0,
  atRisk = 0,
  archived = 0,
  freeBonusListingCount = 0,
  freeClaimedListingCount = 0,
}) => ({
  total: Number(total),
  active: Number(active),
  inactive: Number(inactive),
  atRisk: Number(atRisk),
  archived: Number(archived),
  freeBonusListingCount: Number(freeBonusListingCount),
  freeClaimedListingCount: Number(freeClaimedListingCount),
});

const Properties = ({
  hasAnyArchivedListings = false,
  isPartialResponse = false,
  listings = [],
  listingCount = {},
  feedClaimAndConvertUpdate = {},
  pager = {},
} = {}) => ({
  hasAnyArchivedListings: Boolean(hasAnyArchivedListings),
  isPartialResponse: Boolean(isPartialResponse),
  listings: listings.map((item) => Property(item)),
  listingCount: ListingCount(listingCount),
  feedClaimAndConvertUpdate: Object(feedClaimAndConvertUpdate),
  pager: KeyPager(pager),
});

export default Properties;

export type PropertiesProps = ReturnType<typeof Properties>;
